import {URLS} from "../constants";
import BaseForm from "./baseform";

export default class BalanceForm extends BaseForm {
	defaultOptions() {
		return {
			ajaxUrl: URLS.BALANCE,
			container: ""
		}
	}
}